const dashboard = {
  title: 'Want to unlock way more useful data about the performance of your webshop?',
  content: 'In our environment for clients we can simulate how your webshop would perform on our servers and give you tips on improvements.',
  videoUrl: 'dQw4w9WgXcQ?autoplay=0&autohide=1&rel=0&enablejsapi=1&origin=https://www.hipex.io',
};

export default dashboard;
